import { STATUS_META } from "@/lib/api";

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-300" };
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${m.cls}`}>
      {m.label}
    </span>
  );
}
